module.exports = __webpack_public_path__ + "media/zapsplat_office_electronic_typewriter_chassis_creak_movement_stress_brother_ax_450_001_33703.d9445526.mp3";